import { render } from "./DetailJob_AS.vue?vue&type=template&id=2e4f1ecb&scoped=true"
import script from "./DetailJob_AS.vue?vue&type=script&lang=js"
export * from "./DetailJob_AS.vue?vue&type=script&lang=js"

import "./DetailJob_AS.vue?vue&type=style&index=0&id=2e4f1ecb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4f1ecb"]])

export default __exports__